import { useEffect } from "react";
import {
  useGetProfilsBesse,
  usePostUtilisateur,
  usePutUtilisateur,
} from "../../../hooks/Utilisateurs";
import { Utilisateur } from "../../../services/Api/swagger";
import { Selectors as UtilisateursSelectors } from "../../../redux/Utilisateurs";
import Types from "Types";
import { useSelector } from "react-redux";
import { UtilisateurBesseFormData } from "../UtilisateurBesseForm";

export const useModifierUtilisateurBesse = () => {
  const utilisateurConnecte = useSelector((state: Types.RootState) =>
    UtilisateursSelectors.getUtilisateurConnecte(state)
  );
  const utilisateur = useSelector((state: Types.RootState) =>
    UtilisateursSelectors.getUtilisateur(state)
  );

  const initialValues: UtilisateurBesseFormData | undefined = utilisateur && {
    ...utilisateur,
    identifiant: utilisateur.identifiant || "0",
    profilBesse: utilisateur.profilBesse?.toString() || "0",
  };
  const { mutate: mutateProfilBesse, data: profilsBesse } =
    useGetProfilsBesse();

  useEffect(() => {
    mutateProfilBesse("AGREMENT");
  }, []);

  const {
    mutate: mutateAddUtilisateur,
    isLoading: utilisateurFetching,
    error: utilisateurError,
    reset: resetPutUtilisateur,
  } = usePutUtilisateur();
  const modifierUtilisateur = (param: {
    username: string;
    body: Utilisateur;
  }) => {
    mutateAddUtilisateur(param);
  };

  return {
    profilsBesse,
    modifierUtilisateur,
    utilisateurFetching,
    utilisateurError,
    resetPutUtilisateur,
    utilisateurConnecte,
    utilisateur,
    initialValues,
  };
};
